"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Select_1 = __importDefault(require("@Components/Selectors/Select"));
const Button_1 = require("@Components/Buttons/Button");
const react_1 = __importDefault(require("react"));
const SelectReasonStep = (props) => {
    const { setStep, reason, setReason } = props;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("h2", null, "Request an update"),
        react_1.default.createElement("p", null, "To submit a request to update a songwriter name, please answer a few questions below."),
        react_1.default.createElement("div", null,
            react_1.default.createElement("p", null, "Tell us why you're requesting an update:"),
            react_1.default.createElement(Select_1.default, { placeholder: '', onValueChange: (value) => setReason(value), options: [
                    {
                        value: 'Misspelling',
                        label: 'Misspelling',
                        id: '1',
                    },
                ] })),
        react_1.default.createElement(Button_1.Button, { mainColor: true, type: 'primary', disabled: !reason, onClick: () => setStep('form') }, "Next")));
};
exports.default = SelectReasonStep;
